var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-container container-fluid mb-7"},[_c('h2',[_vm._t("headline")],2),(_vm.isSupPageTiles)?_c('ce-sub-page-tiles',{attrs:{"tiles":_vm.tiles}}):_c('ce-tiles',{attrs:{"tiny":_vm.isTinyTiles,"tiles":_vm.tiles}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }